import "./App.css";
import { Suspense, lazy } from "react";
import { useLenis } from "./lib/useLenis";
import { SiteHeader } from "./components/SiteHeader";
import { Hero } from "./components/Hero";
import { CourseShowcase } from "./components/CourseShowcase";
import { BurKitSection } from "./components/BurKitSection";

const CurriculumSection = lazy(() => import("./components/CurriculumSection").then((m) => ({ default: m.CurriculumSection })));

const MarqueeStrip = lazy(() => import("./components/MarqueeStrip").then((m) => ({ default: m.MarqueeStrip })));
const CertificateSection = lazy(() => import("./components/CertificateSection").then((m) => ({ default: m.CertificateSection })));
const FlexiPaySection = lazy(() => import("./components/FlexiPaySection").then((m) => ({ default: m.FlexiPaySection })));
const LearningOutcomesSection = lazy(() => import("./components/LearningOutcomesSection").then((m) => ({ default: m.LearningOutcomesSection })));
const WhatYouGet = lazy(() => import("./components/WhatYouGet").then((m) => ({ default: m.WhatYouGet })));
const MentorSection = lazy(() => import("./components/MentorSection").then((m) => ({ default: m.MentorSection })));
const SocialProofSection = lazy(() => import("./components/SocialProofSection").then((m) => ({ default: m.SocialProofSection })));
const FAQSection = lazy(() => import("./components/FAQSection").then((m) => ({ default: m.FAQSection })));
const SiteFooter = lazy(() => import("./components/SiteFooter").then((m) => ({ default: m.SiteFooter })));
const CountdownBanner = lazy(() => import("./components/CountdownBanner").then((m) => ({ default: m.CountdownBanner })));

function App() {
  useLenis();

  return (
    <div className="min-h-screen bg-bone text-ink font-sans">
      <SiteHeader />
      <main>
        <Hero />
        <CourseShowcase />
        <Suspense fallback={null}>
          <CurriculumSection />
        </Suspense>
        <BurKitSection />
        <Suspense fallback={null}>
          <MarqueeStrip />
          <CertificateSection />
          <FlexiPaySection />
          <LearningOutcomesSection />
          <WhatYouGet />
          <MentorSection />
          <SocialProofSection />
          <FAQSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <SiteFooter />
        <CountdownBanner />
      </Suspense>
    </div>
  );
}

export default App;
